import React, { createContext, useContext, useState, useCallback } from 'react';

const SuccessModalContext = createContext();

export const useSuccessModal = () => {
    return useContext(SuccessModalContext);
};

export const SuccessModalProvider = ({ children }) => {
    const [successMsg, setSuccessMsg] = useState(null);
    const [onConfirmCallback, setOnConfirmCallback] = useState(null);

    const showSuccess = useCallback((message, onConfirm = null) => {
        setSuccessMsg(message);
        if (onConfirm) {
            setOnConfirmCallback(() => onConfirm);
        } else {
            setOnConfirmCallback(null);
        }
    }, []);

    const handleClose = () => {
        setSuccessMsg(null);
        if (onConfirmCallback) {
            onConfirmCallback();
        }
    };

    return (
        <SuccessModalContext.Provider value={{ showSuccess }}>
            {children}

            {successMsg && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 999999,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', animation: 'fadeIn 0.2s'
                }}>
                    <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '12px', width: '90%', maxWidth: '400px', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' }}>
                        <div style={{ marginBottom: '15px' }}>
                            <h2 style={{ margin: 0, fontSize: '22px', fontWeight: 'bold', color: '#111827' }}>Success</h2>
                        </div>
                        <p style={{ color: '#4B5563', fontSize: '15px', marginBottom: '25px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                            {successMsg}
                        </p>
                        <button
                            onClick={handleClose}
                            style={{
                                backgroundColor: '#2E4B4C', color: 'white', padding: '10px 40px',
                                border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer',
                                fontSize: '15px', transition: 'background-color 0.2s'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1d3132'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2E4B4C'}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </SuccessModalContext.Provider>
    );
};
